export default "__VITE_ASSET__0DJtmTdo__"